import { AmLogo } from '@approvalmax/ui';
import { FC, memo } from 'react';

import { LogoContainer, Root, StyledLoadingBar, Title, TitleLine } from './MobileLogo.styles';
import { LogoProps } from './MobileLogo.types';

const Logo: FC<LogoProps> = memo((props) => {
    const { loading, title } = props;

    return (
        <Root>
            <LogoContainer>
                <AmLogo width={207} height={30} />
            </LogoContainer>

            {title && (
                <TitleLine>
                    <Title>{title}</Title>
                </TitleLine>
            )}

            <StyledLoadingBar $active={loading} />
        </Root>
    );
});

export default Logo;
